var map = {
	"./gallery-wip-handle_00.jpg": 4992,
	"./gallery-wip-handle_01.jpg": 4993,
	"./gallery-wip-handle_02.jpg": 4994,
	"./gallery-wip-handle_03.jpg": 4995,
	"./gallery-wip-handle_04.jpg": 4996,
	"./gallery-wip-handle_05.jpg": 4997,
	"./gallery_00.jpg": 4998,
	"./gallery_01.jpg": 4999,
	"./gallery_02.jpg": 5000,
	"./gallery_03.jpg": 5001,
	"./gallery_04.jpg": 5002,
	"./gallery_05.jpg": 5003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4991;